export enum DataQualityRejectionTabs {
    Customers,
    Buildings,
    LTPoles,
    Transformers
}
